module.exports = __webpack_public_path__ + "media/images/dummy/dummy_banner-a7135ed1c0b9bfd206478731600758c7.jpg";